import { CanvasTokenType, CanvasTokenTypeObject, CanvasToken } from '@fullstory/mobile-flatbuffers';

export class CanvasTokenDef {
  public constructor(
    public token: CanvasToken,
    public keyName: string,
    public type: CanvasTokenType,
    public object: CanvasTokenTypeObject,
  ) {}

  public expectType(type: CanvasTokenType) {
    if (this.type != type) {
      throw new Error(`Expected '${type}' but was '${this.type}'`);
    }
  }
}

export class CanvasTokenDefs {
  private tokens: CanvasTokenDef[] = [];

  public constructor(definition: Int8Array) {
    this.tokens.push(
      new CanvasTokenDef(CanvasToken.OP, 'op', CanvasTokenType.OP, CanvasTokenTypeObject.NONE),
    );
    for (let i = 0; i < definition.length; i += 2) {
      const op = <CanvasToken>definition[i];
      const type = <CanvasTokenType>(definition[i + 1] & 0xf);
      const object = <CanvasTokenTypeObject>(definition[i + 1] >>> 4);
      if (CanvasToken[op]) {
        this.tokens.push(
          new CanvasTokenDef(op, CanvasToken[op].replace(/_/g, '').toLowerCase(), type, object),
        );
      } else {
        console.log(`Missing op: ${op}`);
      }
    }
  }

  public decode(n: number) {
    if (n > this.tokens.length || n < 0) {
      throw new Error(`Invalid token: ${n}`);
    }
    return this.tokens[n];
  }
}
